import { render, staticRenderFns } from "./SolidImageIcon.vue?vue&type=template&id=3766d010&scoped=true"
import script from "./SolidImageIcon.vue?vue&type=script&lang=js"
export * from "./SolidImageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3766d010",
  null
  
)

export default component.exports